<template>
  <div class="order-list tt-custom-tab single-income">
    <div class="search-bar">
      <div>
        <el-select style="width:100%;" v-model="searchForm.express_company_id" clearable filterable
                   :popper-append-to-body="false"
                   @change="changeCompany"
                   class="input-width" placeholder="物流公司">
          <el-option v-for="(item,i) in companyOption" :key="i" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div style="margin-left: 20px">
        <el-select style="width:100%;" v-model="searchForm.account_id" clearable filterable
                   :popper-append-to-body="false"
                   class="input-width" placeholder="物流公司账号">
          <el-option v-for="(item,i) in accountOption" :key="i" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div style="margin-left: 20px">
        <el-input placeholder="物流单号" clearable v-model="searchForm.transport_store_number"></el-input>
      </div>
    </div>
    <div class="search-bar seprator">
      <div style="display:flex;align-items:center;">
        <span>
            {{totalCount}}个转运&nbsp;&nbsp;
        </span>
        <!--<el-button style="width:70px;" v-show="mailList.filter(i=>i.isSelected).length" :loading="multipleUpdating" class="block btn-14" type="info" @click="updateMultipleMail()">批量更新</el-button>-->
      </div>
      <div>
        <div style="display:inline-block;">
          <el-date-picker format="yyyy-MM-dd HH:mm" v-model="timeRange" type="datetimerange" range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']" @change="search">
          </el-date-picker>
        </div>
        <div style="display:inline-block;">
          <el-input class="commbo-input" style="width:500px;" clearable
                    v-model="searchWord">
            <el-select class="search-preix" v-model="keyword_type" slot="prepend" placeholder="请选择" style="width:120px;"
            >
              <!--<el-option label="全文搜索" value="0"></el-option>-->
              <el-option label="收件地址" value="1"></el-option>
            </el-select>
            <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
          </el-input>
        </div>
      </div>
    </div>
    <div class="table">
      <div class="table-head">
        <div v-for="c in columns" :style="{width:c.width}">
          {{ c.name }}
        </div>
        <div style="opacity:0">
          <i class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="table-body pool">
        <el-collapse class="customCollapse2" v-model="activeName" accordion style="width:100%;"
                     @change="changeCollapse">
          <el-collapse-item v-for="(r,index) in dataList" :name="index" :key="index">
            <template slot="title">
              <div class="table-row-title" style="line-height:1;width:100%;">
                <div style="width: 40px;position: relative;top: -2px;color: #1aad19;">
                  <i style="font-size: 20px;" class="el-icon-truck"></i>
                </div>
                <div v-for="(c,idx) in columns" :key="idx" :style="{width:c.width}">
                  <template v-if="c.field=='time'">
                    <p style="font-size: 16px;padding-bottom: 5px;">{{ r.date_display }}</p>
                    <p style="color:#666;">{{ r.time_display }}</p>
                  </template>
                  <template v-if="c.field=='detail'">
                    <template>
                      <p style="font-size: 16px;padding-bottom: 5px;">{{ `${r.express_company_name}
                        #${r.transport_store_number}` }}</p>
                      <p style="color:#666;">{{ `${r.receive_address} ` }}</p>
                    </template>
                  </template>
                  <template v-if="c.field=='price'">
                    <p v-html="evalPrice(r)" style="font-size: 16px;">
                    </p>
                  </template>
                </div>
              </div>
            </template>
            <div>
              <!--<Mail :good_number="good_number" :r="r" :index="index" @updateMail="updateMail"></Mail>-->
              <BillBody v-if="status" :r="r"></BillBody>
              <div style="clear:both;"></div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="yd-pagination" v-if="totalCount / searchForm.limit > 1">
      <el-pagination :page-size="searchForm.limit" :pager-count="5" :current-page.sync="searchForm.page"
                     layout="prev, pager, next"
                     next-text="下一页" prev-text="上一页" :total="totalCount" @current-change="search">
      </el-pagination>
    </div>


  </div>
</template>

<script>
    import api from '../../../services/api.js'
    import BillBody from './BillBody'
    import {CURRENCIES} from "../../../services/constant";

    let _ = require('lodash')

    export default {
        name: 'cartList',
        components: {
            BillBody: BillBody
        },
        data() {
            return {
                status: false,
                activeName: '0',
                searchWord: '',
                keyword_type: '1',
                columns: [
                    {name: '创建时间', field: 'time', width: '160px'},
                    {name: '账单详情', field: 'detail', width: 'calc(100% - 360px)'},
                    {name: '金额', field: 'price', width: '100px'},
                ],
                searchForm: {
                    express_company_id: '',
                    account_id: '',
                    transport_store_number: '',
                    page: 1,
                    limit: 10,
                },
                timeRange: [],
                companyOption: [],
                accountOption: [],
                dataList: [],
                totalCount: 0

            }
        },
        async mounted() {
            this.timeRange = [new Date(new Date().getTime() - 30 * 24 * 3600 * 1000), new Date()];
            let res = await api.getExpressCompanyListForOutbound(this);
            this.companyOption = res.body.result;
            await this.search();
        },
        methods: {
            evalPrice(r) {
                if (r.transport_amount_currency == r.tax_amount_currency) {
                    let a = isNaN(Number(r.transport_amount)) ? 0.00 : Number(r.transport_amount);
                    let b = isNaN(Number(r.tax_amount)) ? 0.00 : Number(r.tax_amount);
                    let c = r.html.items_price || 0.00;
                    let num = this.$decimalFormat((a + b + c), 2);
                    if (isNaN(num)) {
                        num = 0.00
                    }
                    let symbol = '';
                    if (r.transport_amount_currency === 'CAD') {
                        symbol = 'C$';
                    }
                    let temp = r.tax_amount_currency;
                    if (temp) {
                        symbol = CURRENCIES.find(i => i.value == temp).symbol
                    }
                    return `${symbol}${num}<span style="font-size: 12px">${r.transport_amount_currency}</span>`;
                }
                return '--';
            },
            generateDateDisplay(datestring) {
                let today = new Date()
                let yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)
                let today_string = this.$moment(today).format('YYYY-MM-DD')
                let yest_string = this.$moment(yesterday).format('YYYY-MM-DD')
                if (datestring == today_string)
                    return '今天';
                if (datestring == yest_string)
                    return '昨天';
                return datestring
            },
            async changeCollapse(val) {

            },
            search() {
                const generateParams = () => {
                    let params = {};
                    if (this.timeRange && this.timeRange.length) {
                        params.create_time_from = this.$moment(this.timeRange[0]).format('YYYY-MM-DD HH:mm:ss')
                        params.create_time_to = this.$moment(this.timeRange[1]).format('YYYY-MM-DD HH:mm:ss')
                    }
                    params.limit = this.searchForm.limit;
                    params.page = this.searchForm.page;

                    for (let p in this.searchForm) {
                        if (this.searchForm[p])
                            params[p] = this.searchForm[p]
                    }

                    if (this.searchWord) {
                        switch (this.keyword_type) {
                            case '1':
                                params.keyword = this.searchWord;
                                break;
                            case '2':
                                params.tracking_number = this.searchWord;
                                break;
                            case '3':
                                params.merchant_order_number = this.searchWord;
                                break;
                        }
                    }
                    return params
                }
                let params = generateParams();
                this.getList(params)
            },
            async changeCompany(val) {
                let res = await api.getZhuanyunAccountListByExpressCompany(this, {express_company_id: val});
                this.accountOption = res.body.result;
            },
            async getList(params) {
                this.status = false;

                function evalWeight(r) {
                    let weight, real;
                    weight = isNaN(r.weight_value) ? '--' : r.weight_value + r.weight_unit;
                    real = isNaN(r.weight_value_real) ? '--' : r.weight_value_real + r.weight_unit_real;
                    let arr = [{name: '包裹重量', value: weight}, {name: '收费重量', value: real}]
                    return arr.filter(x => x.value != '--');
                }

                function evalMoney(r) {
                    // {{ r.transport_amount }}{{r.transport_amount_currency}}| {{ r.tax_amount }}{{r.tax_amount_currency}}
                    let tr, tx;
                    tr = !r.transport_amount || isNaN(r.transport_amount) ? '--' : r.transport_amount + r.transport_amount_currency
                    tx = !r.tax_amount || isNaN(r.tax_amount) ? '--' : r.tax_amount + r.tax_amount_currency
                    let arr = [{name: '运费', value: tr}, {name: '税费', value: tx}]
                    return arr.filter(x => x.value != '--');
                }

                let res = await api.getOutboundDetailList(this, params)
                let resCount = await api.countOutboundDetailList(this, params);
                this.totalCount = +resCount.body.result;
                this.dataList = res.body.result.map(item => {
                    if (item.create_time) {
                        item.date_display = this.generateDateDisplay(item.create_time.split(' ')[0])
                        item.time_display = item.create_time.split(' ')[1]
                        try {
                            item.html = JSON.parse(item.html);
                        } catch (e) {
                            //不是json字符串不处理
                        }
                        try {
                            item.json2 = JSON.parse(item.json);
                            if (item.express_company_id == '896') {
                                if (item.json2[17].key == '包裹明细') {
                                    item.json2.splice(17, 0, {value: ''})
                                }
                            }
                        } catch (e) {
                            //不是json字符串不处理
                        }
                    }
                    item.weight_label = evalWeight(item);
                    item.money_label = evalMoney(item);
                    return item;
                });
                this.status = true;
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .empty-content {
    padding: 50px 0 50px;
  }
</style>

<style lang="scss">
  .order-list {
    margin-bottom: 80px;

    .el-tabs__content {
      overflow: visible;
    }
  }

  .search-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;

    &.seprator {
      justify-content: space-between;
    }
  }

  .table {
    margin-top: 43px;
    overflow-x: auto;
    overflow-y: hidden;

    .table-head,
    .table-body {
      display: flex;
    }

    .table-head {
      padding: 18px 11px 18px 21px;
      border-left: 2px solid transparent;
      border-right: 2px solid transparent;
    }

    .table-row-title {
      display: flex;
    }

    .table-head {
      color: #333;
    }

    .seporater-order {
      padding: 0 50px;
      height: 40px;
      border: 1px solid #D7D7D7;
      border-top: none;
      line-height: 40px;
    }

    .table-row-content {
      //display:flex;
      padding: 25px 50px 30px;
      border: 1px solid #D7D7D7;
      border-top: none;

      &.order {
        display: block;
        border-top: 1px solid #D7D7D7;
      }
    }

    .table-row-seperator {
      float: left;
      height: 33px;
      width: 100%;
      border-left: 1pX dashed #D7D7D7;
      border-right: 1px dashed #D7D7D7;
    }
  }

  .yd-pagination {
    margin-top: 30px;
  }

  .redirct {
    font-size: 24px;
    line-height: 33px;
    margin-top: 54px;
    padding-bottom: 70px;

    .completion {
      background-image: url('../../../assets/images/Group@2x.png');
      background-position: 0 0;
      background-size: contain;
    }

    a {
      font-size: 16px;
    }

    p {
      line-height: 24px;
      color: #888
    }
  }

  .product-price label.danger {
    font-size: 18px;
    color: #FF4650;
  }

  .product-item {
    display: flex;
    height: 120px;
    margin-bottom: 30px;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
      margin-bottom: 0;
    }

    .product-detail {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      position: relative;
      top: -3px;
      margin-left: 20px;

      .product-name {
        font-size: 14px;
        color: #333333;
      }

      .product-price {
        line-height: 32px;
        color: black;

        label {
          font-size: 18px;
        }
      }

      .product-price del {
        font-size: 16px;
      }
    }
  }
</style>
<style scoped lang="scss">
  .single-income {
    padding: 0 35px 60px;

    .total {
      .block {
        width: 108px;
        margin-top: 15px;
        margin-bottom: 50px;
      }

      span {
        font-size: 14px;
        color: #333;
        line-height: 26px;
      }

      p {
        font-size: 33px;
        color: #666;
      }
    }

    .header {
      color: #333;
    }

    .list {
      .el-row {
        padding: 0 18px 18px;
        border-bottom: 1px solid #EBEBEB;
        margin-bottom: 18px;
      }

      p {
        font-size: 16px;
        padding-bottom: 5px;
      }

      span {
        color: #666;
      }

      .payInfo {
        font-size: 16px;
        line-height: 26px;
      }
    }

  }

  @media screen and (max-width: 1024px) {
    .single-income {
      padding: 0 0 60px;

      .list {

        .el-row {
          padding: 0 0 18px;
        }

        p {
          line-height: 20px;

        }
      }

      .total {
        .el-row {
          display: inline-block;
        }

        p {
          font-size: 18px;
        }

        .block {
          margin-bottom: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/express_bill/list.vue